import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'components/Select/Select';
import { PROFIT_CENTER_LINKS } from 'constants/formFields';

import type IOption from 'components/MappingModal/interfaces/IOption';
import type { FieldPath } from 'react-hook-form';
import type { TCreateSupplierSchema } from 'utils/validators';
import type IProfitCenterSelectorProps from '../interfaces/IProfitCenterSelectorProps';

import styles from '../sass/ProfitCenterLinks.module.scss';

function ProfitCenterSelector({
  control,
  index,
  placeholder,
  profitCenterOptions,
  recordId,
  onProfitCenterChange,
}: Readonly<IProfitCenterSelectorProps>) {
  const { t } = useTranslation();

  return (
    <div className={`${styles.formRow} ${styles.formRowHalf}`}>
      <Controller
        control={control}
        name={`${PROFIT_CENTER_LINKS}.${index}.profitCenterId` as FieldPath<TCreateSupplierSchema>}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Select
            label={t('ownOperations.fields.profitCentre')}
            placeholder={recordId ? placeholder : t('ownOperations.fields.profitCentre')}
            options={profitCenterOptions}
            value={value ? { value, label: value } : null}
            onChange={(newValue: unknown) => {
              const selectedOption = newValue as IOption | null;
              onChange(selectedOption?.value || '');
              onProfitCenterChange(index, 'profitCenterId', selectedOption?.value || '');
            }}
            error={error?.message}
            menuPosition="absolute"
            isSearchable
            required
          />
        )}
      />
    </div>
  );
}

export default ProfitCenterSelector;
